import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import RichTextField from '@/components/common/RichTextField.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import MediaList from '@/components/media/MediaList.vue';
import { MediaPurpose } from '@/models/media.model';
import {
  LearningItem,
  LearningType,
  titleRules,
  descriptionRules,
  learningTypes,
} from '@/models/learning-item.model';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { LearningActions, LearningState } from '@/stores/learning.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import CategoriesField from '../categories/CategoriesField.vue';
import CategoryField from '../categories/CategoryField.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LearningItemForm',
  props: {
  data: {
    type: Object as PropType<LearningItem>,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { ms: LearningState }>();

const events = useEvents();

const props = __props;

const valid = ref<boolean>(false);

const learningItem = ref<LearningItem>({
  id: NEW_ID,
  title: '',
  author: '',
  url: '',
  duration: '',
  type: LearningType.Other,
  recommendation: '',
  recommended: false,
  published: false,
  languages: [],
  description: '',
  categories: [],
  media: [],
});

const action = computed<string>(() =>
  learningItem.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveLearningItem = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (learningItem.value.id === NEW_ID) {
      success = await store.dispatch(
        LearningActions.AddLearningItem,
        learningItem.value,
      );
    } else {
      success = await store.dispatch(
        LearningActions.UpdateLearningItem,
        learningItem.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved LearningItem',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(LearningActions.GetLearningItems);
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: 'Failed to save Learning Item',
      type: 'error',
    });
  }
};

const updateLanguage = async () => {
  if (learningItem.value.id === NEW_ID) {
    Object.assign(learningItem, { title: '' });
  } else {
    const cat = await store.dispatch(
      LearningActions.GetLearningItem,
      learningItem.value.id,
    );

    if (cat) {
      Object.assign(learningItem.value, { ...cat });
    }
  }
};

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, updateLanguage);
});

onMounted(() => {
  events.on(Event.LanguageChanged, updateLanguage);

  if (props.data) {
    Object.assign(learningItem.value, {
      ...props.data,
    });
  }
});

const removeLabel = async () => {
  if (
    learningItem.value &&
    learningItem.value.id !== NEW_ID &&
    confirm('Are you absolutely sure you want to delete this "LearningItem"?')
  ) {
    store.dispatch(LearningActions.DeleteLearningItem, learningItem.value.id);

    store.commit(Mutations.HideDrawer);
  }
};

const togglePublished = async (published: boolean) => {
  if (learningItem.value.id !== -1) {
    store.dispatch(LearningActions.PublishLearningItem, {
      id: learningItem.value.id,
      published,
    });
  }
  learningItem.value.published = published;
};

const languageOptions = [
  {
    title: 'English',
    value: 'en',
  },
  {
    title: 'Nederlands',
    value: 'nl',
  },
];

function checkUrl(url: string) {
  window.open(url, '_new');
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveLearningItem, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(action.value)) + " a learning item ", 1),
            _createVNode(CurrentLanguage)
          ]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: learningItem.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((learningItem.value.title) = $event)),
                    rules: _unref(titleRules),
                    label: "Title",
                    hint: "Not used on learningItem page. Use a top level header in the description",
                    required: ""
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    disabled: learningItem.value.id === _unref(NEW_ID),
                    onClick: _cache[1] || (_cache[1] = () => togglePublished(!learningItem.value.published)),
                    color: !learningItem.value.published ? 'success' : 'warning'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(learningItem.value.published ? 'Un-publish' : 'Publish'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "color"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: learningItem.value.author,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((learningItem.value.author) = $event)),
                    label: "Creator / Author",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: learningItem.value.type,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((learningItem.value.type) = $event)),
                    items: _unref(learningTypes),
                    label: "Type",
                    required: ""
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: learningItem.value.duration,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((learningItem.value.duration) = $event)),
                    label: "Duration",
                    hint: "Use simple notation in minutes (60, 90, 120)",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: learningItem.value.languages,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((learningItem.value.languages) = $event)),
                    label: "Languages",
                    multiple: "",
                    chips: "",
                    items: languageOptions,
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: learningItem.value.url,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((learningItem.value.url) = $event)),
                    label: "URL",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    color: "info",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (checkUrl(learningItem.value.url))),
                    disabled: learningItem.value.url == ''
                  }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode("Check")
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(RichTextField, {
            label: "Description",
            height: 200,
            rules: _unref(descriptionRules),
            modelValue: learningItem.value.description,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((learningItem.value.description) = $event)),
            media: learningItem.value.media
          }, null, 8, ["rules", "modelValue", "media"]),
          _createVNode(CategoryField, {
            main: "",
            disabled: "",
            modelValue: learningItem.value.mainCategory,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((learningItem.value.mainCategory) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(CategoriesField, {
            modelValue: learningItem.value.categories,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((learningItem.value.categories) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(RichTextField, {
            label: "Recommendation",
            height: 200,
            modelValue: learningItem.value.recommendation,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((learningItem.value.recommendation) = $event)),
            media: learningItem.value.media
          }, null, 8, ["modelValue", "media"]),
          _createVNode(_component_v_checkbox, {
            label: "Recommended",
            density: "compact",
            modelValue: learningItem.value.recommended,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((learningItem.value.recommended) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(MediaList, {
            modelValue: learningItem.value,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((learningItem).value = $event)),
            required: [_unref(MediaPurpose).Main]
          }, null, 8, ["modelValue", "required"]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "button",
                    color: "warning",
                    onClick: removeLabel,
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("Delete")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})